import type { DocEntityHandle } from "./docEntityHandleTypes";

export type LabelableEntityHandle = Extract<
  DocEntityHandle,
  {
    type:
      | "ANNOTATION"
      | "CEILING"
      | "PLAN_VIEW"
      | "ELEVATION_VIEW"
      | "SECTION_VIEW"
      | "PROP"
      | "PROP_INSTANCE"
      | "SHEET"
      | "CONTENT_TEMPLATE" // only drawing templates
      | "CONTENT_TEMPLATE_INSTANCE" // only drawing template instances
      | "VIEW_TEMPLATE_OVERRIDE"
      | "COMPONENT_INSTANCE"
      | "ROOM"
      | "ROOF"
      | "FLOOR"
      | "FLOOR_SYSTEM"
      | "FOUNDATION"
      | "STAIR_SYSTEM"
      | "RAILING"
      | "FREEFORM_WALL"
      | "WALL_PLANE_ASSEMBLY"
      | "ELECTRICAL_DEVICE"
      | "OPTION_SET"; // archetype option sets only; INSTANCE_OPTION_SET is derived and inherits its archetype's labels
  }
>;

export type LabelableDocEntityType = LabelableEntityHandle["type"];

// When adding types to this list, you must add a migration that adds an empty label table to the newly added entity types.
export const LabelableDocEntityTypes: LabelableDocEntityType[] = [
  "ANNOTATION",
  "CEILING",
  "PLAN_VIEW",
  "ELEVATION_VIEW",
  "SECTION_VIEW",
  "PROP",
  "PROP_INSTANCE",
  "SHEET",
  "CONTENT_TEMPLATE",
  "CONTENT_TEMPLATE_INSTANCE",
  "VIEW_TEMPLATE_OVERRIDE",
  "COMPONENT_INSTANCE",
  "ROOM",
  "ROOF",
  "FLOOR",
  "FLOOR_SYSTEM",
  "FOUNDATION",
  "STAIR_SYSTEM",
  "RAILING",
  "FREEFORM_WALL",
  "WALL_PLANE_ASSEMBLY",
  "ELECTRICAL_DEVICE",
  "OPTION_SET",
] as const;

/** Labelable entity types that are nested (not stored in a top-level doc table) */
export const NestedLabelableDocEntityTypes: LabelableDocEntityType[] = [];
